export const newcss = {
    loderbox : {
        width: "100%;",
        backgroundColor: "#fff;",
        height: "100vh",
        before:{
            height:"100vh"
        }
    }
}